export const RDX_INTL_APPEND = 'rdx/intl/append';

export const appendIntl = (message) => {
	return { 'type': RDX_INTL_APPEND, 'message': message};
};